import { skipToken } from '@reduxjs/toolkit/query';
import Loader from 'components/Loader';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useGetPartyGroupByIdQuery } from 'store/api/groups';
import { PartyGroupForm } from 'types/groups';
import { useClassifiers } from 'utils/useClassifiers';
import GroupPageForm from './GroupPageForm';
import { GROUP_FORM_CLASSIFIERS, groupDtoToForm } from './groupFormMapping';

const ClassicGroupPageEdit = (): JSX.Element => {
    const { id: groupId } = useParams();

    const { data: partyGroup, isLoading, isError, refetch } = useGetPartyGroupByIdQuery(groupId ?? skipToken);

    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({ codes: GROUP_FORM_CLASSIFIERS });

    // Derive initial form data from fetched party group + classifiers during render (no effect needed).
    const initialData = useMemo<PartyGroupForm | undefined>(
        () => (partyGroup ? groupDtoToForm(partyGroup, classifiers) : undefined),
        [partyGroup, classifiers]
    );

    if (isLoading || isLoadingClassifiers || (initialData === undefined && !isError)) {
        return <Loader />;
    }

    return (
        <GroupPageForm
            type="edit"
            classifiers={classifiers}
            initialData={initialData}
            refetch={() => {
                void refetch();
            }}
        />
    );
};

/** In the new design the group edits card by card on its page: this lands there with the first card open. */
const GroupPageEdit = (): JSX.Element => {
    const isNew = useIsNewDesign();
    const { id } = useParams();
    return isNew ? <Navigate to={`/group/${id}?edit=details`} replace /> : <ClassicGroupPageEdit />;
};

export default GroupPageEdit;
